import { BotPartSlot } from './bot-part-slots';

export interface PartSet<T> {
  [BotPartSlot.TREADS]: T;
  [BotPartSlot.PLATFORM]: T;
  [BotPartSlot.RUDDER]: T;
  [BotPartSlot.HELMET]: T;
}
